const list = {
    or: 'または',
    and: 'そして',
    separator: ',',
};
export default Object.freeze(list);
